export default __webpack_public_path__ + "static/media/feifei_huang.bbaf5293.gif";